import { render, staticRenderFns } from "./DraftSignatureLocation.vue?vue&type=template&id=e073fc4a&scoped=true&"
import script from "./DraftSignatureLocation.vue?vue&type=script&lang=js&"
export * from "./DraftSignatureLocation.vue?vue&type=script&lang=js&"
import style0 from "./DraftSignatureLocation.vue?vue&type=style&index=0&id=e073fc4a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e073fc4a",
  null
  
)

export default component.exports